import { Tabs } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import SettingsProgs from "./settings-progs";
import SettingsPays from "./settings-pays";
import SettingsTags from "./settings-tags";

const Settings = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const items = [
    {
      key: "/settings",
      label: "Программы",
      children: <SettingsProgs />,
    },
    {
      key: "/settings/pays",
      label: "Виды оплат",
      children: <SettingsPays />,
    },
    {
      key: "/settings/tags",
      label: "Метки",
      children: <SettingsTags />,
    },
  ];

  const activeKey = items.find(item => location.pathname === item.key)?.key || items[0].key;

  const onTabChange = (key) => {
    navigate(key);
  };

  return (
    <div className="page">
      <Tabs
        activeKey={activeKey}
        items={items}
        onChange={onTabChange}
        type="card"
      />
    </div>
  );
};

export default Settings;